export type DeepLinkServiceConfig = {
  displayName: string;
  androidPackageName: string;
  androidStoreUrl: string;
  iosStoreUrl: string;
};

export const DEEP_LINK_SERVICE_CONFIG_MAP: Record<string, DeepLinkServiceConfig> = {
    "nest": {
        "displayName": "DOKOPANG",
        "androidPackageName": "org.softwiz.nest",
        "androidStoreUrl": "https://play.google.com/store/apps/details?id=org.softwiz.nest",
        "iosStoreUrl": "https://apps.apple.com/search?term=Nest"
    }
};
